import React from "react";
import { Busy } from "../presentational/busy";
import ReactGA from "react-ga";
import styles from "../../styles/panels/cardCodeInput.css";
import * as utilities from "../../middleware/utilities";

export class CardCodeInput extends React.Component {
  constructor(props) {
    super(props);
    let banner =
      this.props.images.card_code_input_banners[
        Math.floor(
          Math.random() * this.props.images.card_code_input_banners.length
        )
      ];
    this.state = {
      banner: banner,
    };
  }
  componentDidMount() {
    this.codeInput.focus();
    ReactGA.pageview("/Spend/CardCodeInput");
  }
  render() {
    if (this.props.busy) {
      return <Busy />;
    } else {
      return (
        <div className={styles.main}>
          <div
            className={styles.banner}
            style={{ backgroundImage: "url(" + this.state.banner.src + ")" }}
          />
          <div className={styles.inputs}>
            <div
              className={styles.message}
              dangerouslySetInnerHTML={{
                __html: this.props.dictionary.card_code_input_message,
              }}
            />
            <div className={styles.group}>
              <label
                className={
                  styles.label +
                  (this.props.codeValid ? "" : " " + styles.error)
                }
              >
                {this.props.dictionary.card_code_input_code}
              </label>
              <input
                className={
                  styles.input +
                  " " +
                  styles.codeInput +
                  (this.props.codeValid ? "" : " " + styles.error)
                }
                ref={(input) => {
                  this.codeInput = input;
                }}
                value={this.props.code}
                placeholder="   -   "
                maxLength="7"
                onChange={(event) => {
                  let code = event.target.value;
                  code = code.replace(/[^0-9a-zA-Z]/g, "");
                  if (code.length == 3) {
                    let previousValue = this.props.code.replace(
                      /[^0-9a-zA-Z]/g,
                      ""
                    );
                    if (code.length > previousValue.length) {
                      code = code.slice(0, 3) + "-" + code.slice(3);
                    }
                  } else if (code.length > 3) {
                    code = code.slice(0, 3) + "-" + code.slice(3);
                  }
                  this.props.onCodeChanged(code.toUpperCase());
                }}
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    ReactGA.event({
                      category: "User Action",
                      action: "Submit Card Code",
                      label: "User pressed enter in card code",
                    });
                    this.props.onSubmit();
                  }
                }}
              />
              {this.props.codeValid ? null : (
                <div
                  className={styles.errorMessage}
                  dangerouslySetInnerHTML={{
                    __html: this.props.validation.card_code_input_code,
                  }}
                />
              )}
            </div>
            <div className={styles.group}>
              <label
                className={
                  styles.label +
                  (this.props.emailValid ? "" : " " + styles.error)
                }
              >
                {this.props.dictionary.card_code_input_email}
              </label>
              <input
                className={
                  styles.input +
                  " " +
                  styles.emailInput +
                  (this.props.emailValid ? "" : " " + styles.error)
                }
                type="email"
                value={this.props.email}
                placeholder=""
                onChange={(event) => {
                  this.props.onEmailChanged(event.target.value);
                }}
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    ReactGA.event({
                      category: "User Action",
                      action: "Submit Card Code",
                      label: "User pressed enter in email",
                    });
                    this.props.onSubmit();
                  }
                }}
              />
              {this.props.emailValid ? null : (
                <div className={styles.errorMessage}>
                  {this.props.validation.card_code_input_email}
                </div>
              )}
            </div>
            <div className={styles.group}>
              <div className={styles.terms}>
                By clicking continue you're agreeing to our{" "}
                <a
                  href="https://www.tisbest.org/charity-gift-card-terms/"
                  target="_blank"
                >
                  terms
                </a>
                .
              </div>
            </div>
            <div className={styles.commands}>
              <button
                className={styles.button}
                onClick={() => {
                  ReactGA.event({
                    category: "User Action",
                    action: "Clicked Continue Button",
                    label: "/Spend/CardCodeInput",
                  });
                  this.props.onSubmit();
                }}
              >
                {this.props.dictionary.card_code_input_continue}
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
}
